'use strict'

function addFactorUnderline(insight, insightsType) {
  const lineThree = document.querySelector('.line--three')
  const lineTwo = document.querySelector('.line--two')

  if (insightsType === 'segments--consumers') {
    lineThree.innerHTML = lineThree.innerHTML.replace(insight.highlight, match => {
      return `<span>${match}</span>`
    })
  } else {
    lineTwo.innerHTML = lineTwo.innerHTML.replace(insight.highlight, match => {
      return `<span>${match}</span>`
    })
  }
}

export function loadInsight(insightsDataCache) {
  const insightsSegments = document.querySelectorAll('.insights-segments')[0]
  const card = insightsSegments.querySelector('.card')
  const lineOne = card.querySelector('.line--one')
  const lineTwo = card.querySelector('.line--two')
  const lineThree = card.querySelector('.line--three')
  const lineFour = card.querySelector('.line--four')
  const lineFive = card.querySelector('.line--five')
  const insight = insightsDataCache.next()
  const insightsType = insightsDataCache.insightsType
  const twitterShareAnchors = Array.from(insightsSegments.querySelectorAll('.twitter-share'))

  if (insightsType === 'segments--consumers') {
    lineOne.innerHTML = insight.segment
    lineTwo.innerHTML = `${insight.conjunction} ${insight.icon !== '' ? `<img src="${insight.icon}" />` : ''} ${insight.preposition} ${insight.location}` // eslint-disable-line
    lineThree.innerHTML = insight.likelihood
    lineFour.innerHTML = insight.emphasis_modifer
    lineFive.innerHTML = insight.insight
    twitterShareAnchors.forEach(twitterShareAnchor => {
      twitterShareAnchor.setAttribute('href', `https://twitter.com/intent/tweet?text=Check out other audience insights with @foursquare's location intelligence ${insight.shareable_image ? insight.shareable_image : ''} &url=${location.href}`)
    })
  } else {
    lineOne.innerHTML = insight.place
    lineTwo.innerHTML = insight.likelihood
    lineThree.innerHTML = insight.action
    lineFour.innerHTML = insight.bound
    lineFive.innerHTML = insight.comparison
    twitterShareAnchors.forEach(twitterShareAnchor => {
      twitterShareAnchor.setAttribute('href', `https://twitter.com/intent/tweet?text=Check out other place insights with @foursquare's location intelligence ${insight.shareable_image ? insight.shareable_image : ''} &url=${location.href}`)
    })
  }

  if (insight.emphasis_modifer === '' || insight.insight === '') {
    card.classList.add('card--loaded__4')
  } else {
    card.classList.remove('card--loaded__4')
  }

  addFactorUnderline(insight, insightsType)
}
